<!--
  The flash bars of the top-bar layout. With the sidebar on, FlashToast shows
  each flash as a toast and this renders nothing.
-->
<template>
  <div>
    <Alert
      v-for="[type, message] in alerts"
      :key="type"
      :type="type"
      class="rounded-none"
    >
      <template #title>
        {{ message }}
      </template>
    </Alert>
  </div>
</template>

<script setup>
import Alert from './Alert.vue'
import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

const props = defineProps({
  // False with the sidebar on: the toast takes over.
  isShown: { type: Boolean, default: true },
})

const page = usePage()

const alerts = computed(() => {
  const shared = page.props.shared
  if (!props.isShown || !shared?.flash) return []
  // `toast` is not a bar: FlashToast shows it.
  return Object.entries(shared.flash).filter(([type, message]) => {
    return type !== 'toast' && !!message
  })
})
</script>
